<template>
    <div>
        <vx-label size="lg">Name</vx-label>

        <vx-input
            ref="inputRef"
            autofocus
            size="lg"
            :error="displayFirstError(validate.friendly_name)"
            v-model="data.friendly_name"
            ></vx-input>
    </div>
</template>

<script setup>
import { VxLabel, VxInput } from '@voxie/frontend-components';
import useVuelidate from "@vuelidate/core";
import { maxLength, required } from "@vuelidate/validators";
import { ref } from 'vue';
import { useAuthConfigForm } from "~/components/settings/integrations/auth-configs/form/useAuthConfigForm";
import { displayFirstError } from "~/utils/validation";

const { data } = useAuthConfigForm();

const validate = useVuelidate({
    friendly_name: {
        required,
        maxLength: maxLength(80)
    }
}, data)

const inputRef = ref();
const focus = () => inputRef.value?.field?.focus?.()

defineExpose({
    focus
})
</script>
